import React from 'react'
import { useRegisterPublishForm } from './useRegisterPublishForm.vm'
import { RegisterForm } from "../../form/RegisterForm";
import { RegisterViewingSuccess } from "../../registerViewingUser/RegisterViewingSuccess";
import { formDataPublish } from "./registerFormData";
import { observer } from "mobx-react-lite";

interface IProps {
  labelColor: string
  buttonBcgColor: string;
  buttonTextColor: string
}

export const RegisterFormPublishComponent: React.FC<IProps> = observer(({
                                                                          labelColor,
                                                                          buttonBcgColor,
                                                                          buttonTextColor
                                                                        }) => {
  const {
    formik,
    confirmForm,
    emailInfo,
    isRegistered
  } = useRegisterPublishForm()

  if (isRegistered) {
    return <RegisterViewingSuccess labelColor={labelColor}
                                   buttonBcgColor={buttonBcgColor}
                                   buttonTextColor={buttonTextColor}/>
  }

  return <RegisterForm formik={formik}
                       confirmForm={confirmForm}
                       labelColor={labelColor}
                       buttonTextColor={buttonTextColor}
                       buttonBcgColor={buttonBcgColor}
                       formData={formDataPublish}
                       emailInfo={emailInfo}
  />
})
